<template>
  <transition name="slide-up" @after-leave="onAfterLeave">
    <div v-if="isVisible" class="preloader-overlay">
      <!-- Деликатный фоновый радиальный градиент -->
      <div class="preloader-ambient"></div>

      <!-- Центральный логотип -->
      <div class="logo-wrapper">
        <!-- 1. Текст "OZO" с маской overflow: hidden и эффектом Fade-In-Up -->
        <div class="ozo-mask">
          <span class="logo-ozo">OZO</span>
        </div>

        <!-- 2. Слово "direct" с задержкой 1 сек и эффектом неонового свечения #00E676 -->
        <div class="direct-wrap">
          <span class="logo-dot">.</span>
          <span class="logo-direct">direct</span>
        </div>
      </div>

      <!-- Премиальный подзаголовок -->
      <div class="preloader-tagline">Цифровой сервис ресторатора</div>

      <!-- Тонкая линия прогресса внизу экрана -->
      <div class="progress-bar-track">
        <div class="progress-bar-fill"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Preloader",
  props: {
    /** Время показа прелоадера в миллисекундах до начала анимации закрытия */
    duration: {
      type: Number,
      default: 2500,
    },
  },
  data() {
    return {
      isVisible: true,
      timer: null,
    };
  },
  mounted() {
    // Блокируем прокрутку страницы во время показа прелоадера
    if (typeof document !== "undefined") {
      document.body.style.overflow = "hidden";
    }

    // Через 2.5 секунды скрываем прелоадер
    this.timer = setTimeout(() => {
      this.isVisible = false;
      this.$emit("hide");
    }, this.duration);
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.restoreScroll();
  },
  methods: {
    restoreScroll() {
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
      }
    },
    onAfterLeave() {
      this.restoreScroll();
      this.$emit("finish");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

/* Полноэкранный темный графитовый оверлей */
.preloader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background-color: #1c1c1c;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  pointer-events: all;
}

/* Деликатное атмосферное свечение по центру */
.preloader-ambient {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 520px;
  height: 520px;
  background: radial-gradient(
    circle,
    rgba(0, 230, 118, 0.09) 0%,
    rgba(28, 28, 28, 0) 70%
  );
  filter: blur(50px);
  pointer-events: none;
  z-index: 1;
}

/* Центральный блок логотипа */
.logo-wrapper {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
}

/* Невидимая маска для текста "OZO" (overflow: hidden) */
.ozo-mask {
  display: inline-block;
  overflow: hidden;
  padding-bottom: 4px;
}

/* Буквы "OZO" — массивный шрифт, всплывающий снизу (Fade-In-Up) */
.logo-ozo {
  display: inline-block;
  font-family: $font-family-heading;
  font-size: clamp(48px, 9vw, 84px);
  font-weight: 900;
  letter-spacing: -0.03em;
  line-height: 1;
  color: #f8fafc; // светло-серый / белый
  transform: translateY(120%);
  opacity: 0;
  animation: ozoFadeInUp 0.85s cubic-bezier(0.16, 1, 0.3, 1) 0.15s forwards;
}

/* Блок слова ".direct" */
.direct-wrap {
  display: inline-flex;
  align-items: baseline;
  margin-left: 2px;
}

.logo-dot {
  font-family: $font-family-heading;
  font-size: clamp(44px, 8.5vw, 76px);
  font-weight: 900;
  line-height: 1;
  color: #00e676;
  opacity: 0;
  animation: directNeonGlow 0.9s cubic-bezier(0.16, 1, 0.3, 1) 1.15s forwards;
}

/* Слово "direct" — тоньше, появляется через 1с после OZO с неоновым свечением */
.logo-direct {
  display: inline-block;
  font-family: $font-family-heading;
  font-size: clamp(40px, 7.5vw, 68px);
  font-weight: 300;
  letter-spacing: -0.01em;
  line-height: 1;
  color: #00e676;
  opacity: 0;
  animation: directNeonGlow 0.9s cubic-bezier(0.16, 1, 0.3, 1) 1.15s forwards;
}

/* Подзаголовок сервиса под логотипом */
.preloader-tagline {
  position: relative;
  z-index: 2;
  margin-top: 24px;
  font-family: $font-family-base;
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  opacity: 0;
  animation: taglineFadeIn 0.7s ease 1.35s forwards;

  @media (max-width: 480px) {
    font-size: 11px;
    letter-spacing: 0.12em;
    margin-top: 18px;
  }
}

/* Тонкая линия прогресса в самом низу экрана */
.progress-bar-track {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.05);
  z-index: 3;
  overflow: visible;
}

.progress-bar-fill {
  position: relative;
  height: 100%;
  width: 0%;
  background: #00e676;
  box-shadow: 0 0 12px #00e676, 0 0 24px rgba(0, 230, 118, 0.6);
  animation: progressFill 2.5s cubic-bezier(0.22, 1, 0.36, 1) forwards;

  /* Светящийся бегунок на острие полосы прогресса */
  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 0 8px #00e676, 0 0 16px #00e676;
  }
}

/* ==============================================================================
   Анимации (Keyframes)
   ============================================================================== */

/* 1. Всплытие "OZO" снизу из невидимой маски */
@keyframes ozoFadeInUp {
  0% {
    transform: translateY(120%);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}

/* 2. Появление "direct" с неоновым свечением */
@keyframes directNeonGlow {
  0% {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
    text-shadow: none;
    filter: blur(6px);
  }
  50% {
    opacity: 0.9;
    filter: blur(1px);
    text-shadow: 0 0 12px rgba(0, 230, 118, 0.9),
      0 0 24px rgba(0, 230, 118, 0.6);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
    filter: blur(0);
    text-shadow: 0 0 14px rgba(0, 230, 118, 0.85),
      0 0 28px rgba(0, 230, 118, 0.5), 0 0 42px rgba(0, 230, 118, 0.3);
  }
}

/* 3. Плавное появление слогана */
@keyframes taglineFadeIn {
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 4. Заполнение полосы прогресса слева направо */
@keyframes progressFill {
  0% {
    width: 0%;
  }
  20% {
    width: 25%;
  }
  60% {
    width: 65%;
  }
  85% {
    width: 90%;
  }
  100% {
    width: 100%;
  }
}

/* ==============================================================================
   Vue Transition: slide-up (сдвиг экрана загрузки вверх, открывающий сайт)
   ============================================================================== */
.slide-up-leave-active {
  transition: transform 0.85s cubic-bezier(0.76, 0, 0.24, 1),
    opacity 0.6s cubic-bezier(0.76, 0, 0.24, 1);
}

.slide-up-leave-to {
  transform: translateY(-100%);
  opacity: 0.96;
}
</style>
